import { render, staticRenderFns } from "./ReturnModal.vue?vue&type=template&id=c5b78966"
import script from "./ReturnModal.vue?vue&type=script&lang=js"
export * from "./ReturnModal.vue?vue&type=script&lang=js"
import style0 from "./ReturnModal.vue?vue&type=style&index=0&id=c5b78966&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports